import { environment } from '../../../environments/environment';

export const SocialsIcon = {
  GOOGLE: `${environment.icons_url}/social-google-icon.png`,
  LINKEDIN: `${environment.icons_url}/social-linkedin-icon.png`,
  OFFICE: `${environment.icons_url}/social-office-icon.png`,
};
